class Wishlist {
  static getProductId() {
    if (document.querySelector("select[name='id']")) {
      return document.querySelector("select[name='id']").getAttribute('data-product-id');
    } else {
      return
    }
  }

  static getVariantId() {
    if (document.querySelector("select[name='id']")) {
      return document.querySelector("select[name='id']").value;
    } else {
      return
    }
  }

  static getItems() {
    return JSON.parse(localStorage.getItem('wishlist-items'));
  }

  static addVariant(variantId) {
    if (!variantId) {
      variantId = Wishlist.getVariantId();
    }

    if (!variantId) {
      console.warn("No variantId available, can't add variant to wishlist");
    }

    const variant = VariantInfo[variantId]

    if (!variant) {
      console.warn("No variant available, can't add variant to wishlist");
    }

    const customInformation = Wishlist.extractCustomInformation();

    if (customInformation && customInformation != {}) {
      Object.assign(variant, customInformation)
    }

    let wishlistItems = Wishlist.getItems();

    if (wishlistItems === null) {
      wishlistItems = {[variantId]: variant};
      localStorage.setItem(Wishlist.key, JSON.stringify(wishlistItems))
    } else {
      wishlistItems[variantId] = variant;
      localStorage.setItem(Wishlist.key, JSON.stringify(wishlistItems))
      const productId = variant.productId;
      if(productId) {
      // if variant of a wishlist product item is added, the variant should replace the product
        Wishlist.removeItem(productId);
      }
    }
    Wishlist.fillPDPHeart();
    Wishlist.updateHearts();
    Wishlist.updateCounter();
  }

  static addOrRemoveVariant(variantId){
    if (!variantId) {
      variantId = Wishlist.getVariantId();
    }

    const wishlistItems = Wishlist.getItems();
    if (wishlistItems && Object.keys(wishlistItems).length > 0 && Object.keys(wishlistItems).includes(variantId)) {
      Wishlist.removeItem(variantId);
    } else {
      Wishlist.addVariant(variantId);
    }
  }

  static addOrRemoveProduct(productId){
    const wishlistItems = Wishlist.getItems();
    if (wishlistItems && Object.keys(wishlistItems).length > 0) {
      const relevantWishlistItems = Object.values(wishlistItems).filter(item => item.productId == productId)
      if (relevantWishlistItems && relevantWishlistItems.length > 0) {
        relevantWishlistItems.forEach(item => Wishlist.removeItem(item.id));
      } else {
        Wishlist.addProduct(productId);
      }
    } else {
      Wishlist.addProduct(productId);
    }
  }

  static extractCustomInformation(){
    const customOptions = document.getElementsByClassName('variant-wrapper--custom')
    let options = {};
    if (customOptions && customOptions.length > 0) {
      // TODO: generalize it!
      let underframeFieldSet = document.getElementsByName("Underframe");
      if (underframeFieldSet && underframeFieldSet.length > 0) {
        let underframeFieldSetId = underframeFieldSet[0].id;
        // TODO: use variant-wrapper--custom here
        let underframeLabel = document.querySelector("label[for=" + underframeFieldSetId + "]");
        if (underframeLabel) {
          let optionValues = underframeLabel.innerText.split(' — ');
          if (optionValues.length > 1) {
            options['CustomOptionNames'] = [optionValues[0]]
            options['CustomOptionValues'] = [optionValues[1]]
          }
          return options
        } else {
          return {};
        }
      }
    } else {
      return {};
    }
  }

  static removeItem(itemId) {
    if (!itemId) {
      console.warn("No itemId available, can't remove item to wishlist");
      return;
    }

    let wishlistItems = Wishlist.getItems();
    if (wishlistItems === null) {
      console.warn("Wishlist not available. Can't remove variantId from wishlist wishlist");
    } else if (Object.keys(wishlistItems).includes(String(itemId))) {
      delete wishlistItems[String(itemId)];
      if (Object.keys(wishlistItems).length === 0) {
        localStorage.setItem(Wishlist.key, null)
      } else {
        localStorage.setItem(Wishlist.key, JSON.stringify(wishlistItems))
      }
      Wishlist.emptyPDPHeart();
      Wishlist.updateCounter();
      Wishlist.updateHearts();
    }
  }

  static addProduct(productId) {
    if (!productId) {
      console.warn("No productId available, can't add product to wishlist");
    }

    if (!ProductInfo) {
      console.warn("No ProductInfo available, can't add product to wishlist");
    }

    const product = ProductInfo[productId]

    if (!product) {
      console.warn("No variant available, can't add product to wishlist");
      return
    }

    let wishlistItems = Wishlist.getItems();
    if (wishlistItems === null) {
      wishlistItems = {[productId]: product}
    } else {
      wishlistItems[productId] = product
    }
    localStorage.setItem(Wishlist.key, JSON.stringify(wishlistItems))
    Wishlist.updateHearts();
    Wishlist.updateCounter();
  }

  static removeAllItems() {
    Wishlist.emptyPDPHeart();
    localStorage.setItem(Wishlist.key, null);
    Wishlist.updateCounter();
  }

  static itemCount() {
    let wishlistItems = Wishlist.getItems();
    if (wishlistItems === null) {
      return 0;
    } else {
      return Object.keys(wishlistItems).length;
    }
  }

  static updateCounter() {
    if (document.getElementsByClassName("wishlist-counter").length > 0) {
      const wishlistCounters = Array.from(document.getElementsByClassName("wishlist-counter"));
      const itemCountOld = wishlistCounters[0].dataset.wishlistCounter;
      const itemCountNew = Wishlist.itemCount();

      if (itemCountNew === 0) {
        wishlistCounters.forEach(item => item.dataset.wishlistCounter = '')
        wishlistCounters.forEach(item => item.classList.remove("wishlist-count"))
      } else if (itemCountOld === '') {
        wishlistCounters.forEach(item => item.dataset.wishlistCounter = itemCountNew)
        wishlistCounters.forEach(item => item.classList.add("wishlist-count"))
      } else {
        wishlistCounters.forEach(item => item.dataset.wishlistCounter = itemCountNew)
      }
    }
  }

  static render() {
    let source = document.getElementById('WishlistTemplate').innerHTML;
    let template = Handlebars.compile(source);
    let wishlistItems = Wishlist.getItems();
    if (wishlistItems) {
      console.log(wishlistItems);
      wishlistItems = Object.values(wishlistItems)
      wishlistItems.map(function(item){
        item['showStubPriceInfo'] = item.hasOwnProperty('productId') && !item.hasOnlyDefaultVariant && !item.hasOwnProperty('variantId');
        if (item['optionNames'] && item['optionValues']) {
          item['options'] = item['optionNames'].map((optionName, index) => optionName.concat(': ',item['optionValues'][index]));
          // TODO: rework custom option handling
          if (item.hasOwnProperty('title_custom')) {
            item['title'] = `${item['title']}${item['title_custom']}`;
          }
        }
        if (item['CustomOptionNames'] && item['CustomOptionValues']) {
          item['customOptions'] = item['CustomOptionNames'].map((optionName, index) => optionName.concat(': ',item['CustomOptionValues'][index]));
        }
        if (item['price'] !== undefined) {
          //item['price'] = calcPrice(item['price'], item.collections);
          item['price'] = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(calcPrice(item['price'], item['collections']));
          if("CH" === localStorage.getItem("countryCode") ) item['price'] = item['price'].replace("€", "CHF");
        }
      })
    } else {
      wishlistItems = [];
    }

    let data = {"items": wishlistItems}
    $("#WishlistContainer").append(template(data));

    $(".custom-wishlist-delete").click(function(event){
      event.preventDefault();
      let itemId = $(this).data()["wishlistItemId"];

      Wishlist.removeItem(itemId);
      Wishlist.updateCounter();

      if (Wishlist.itemCount() === 0) {
        $('#Wishlist--filled').each((_, item) => {return item.style = 'display:none;'})
        $('#Wishlist--empty').each((_, item) => {return item.style = 'display:block;'})
      } else {
        Array.from(document.getElementsByClassName(`id-${itemId}`)).forEach(item => item.remove())
      }
    });
  }

  static fillPDPHeart() {
    let wishlistItems = Wishlist.getItems();
    if (wishlistItems) {
      if (Object.keys(wishlistItems).includes(Wishlist.getVariantId())) {
        const pdpWishlistButton = document.querySelectorAll('.wishlist-btn-container > .wishlist-btn')
        if (pdpWishlistButton && pdpWishlistButton.length > 0) {
          // remove this, to allow to remove variant from wishlist
          pdpWishlistButton[0].setAttribute("disabled", "true");
          pdpWishlistButton[0].children[0].classList.remove("fa-heart-o");
          pdpWishlistButton[0].children[0].classList.add("fa-heart");
        }
      }
    }
  }

  static emptyPDPHeart() {
    const wishlistItems = Wishlist.getItems();
    if (!wishlistItems || !Object.keys(wishlistItems).includes(Wishlist.getVariantId())) {
      const pdpWishlistButton = document.querySelectorAll('.wishlist-btn-container > .wishlist-btn')
      if (pdpWishlistButton && pdpWishlistButton.length > 0) {
        // remove this, to allow to remove variant from wishlist
        pdpWishlistButton[0].setAttribute("disabled", "false");
        pdpWishlistButton[0].children[0].classList.add("fa-heart-o");
        pdpWishlistButton[0].children[0].classList.remove("fa-heart");
      }
    }
  }

  static updateHearts() {
    const wishlistItems = Wishlist.getItems();
    const wishlistButtons = Array.from(document.getElementsByClassName('wishlist-btn'))
    if (wishlistItems) {
      const wishlistItemIds = Object.keys(wishlistItems).concat(Object.values(Wishlist.getItems()).map(item => item.productId))

      wishlistButtons.forEach(function(wishlistButton){
        if (wishlistButton.id) {
          if (wishlistItemIds.includes(wishlistButton.id)) {
            if (wishlistButton.children.length > 0 && wishlistButton.children[0].classList.contains('fa-heart-o')) {
              wishlistButton.children[0].classList.remove("fa-heart-o");
              wishlistButton.children[0].classList.add("fa-heart");
            }
          } else if (wishlistButton.children.length > 0 && wishlistButton.children[0].classList.contains('fa-heart')){
            wishlistButton.children[0].classList.remove("fa-heart");
            wishlistButton.children[0].classList.add("fa-heart-o");
          }
        }
      })
    } else {
      wishlistButtons.forEach(function(wishlistButton){
        if (wishlistButton.children.length > 0 && wishlistButton.children[0].classList.contains('fa-heart')) {
          wishlistButton.children[0].classList.remove("fa-heart");
          wishlistButton.children[0].classList.add("fa-heart-o");
        }
      })
    }
  }


  static updatePDPHeart() {
    Wishlist.emptyPDPHeart();
    Wishlist.fillPDPHeart();
  }
}

Wishlist.key = "wishlist-items";

if (document.getElementById('WishlistContainer')) {
  Wishlist.render();
}
Wishlist.updateCounter();
Wishlist.fillPDPHeart();

let variantInputs = document.getElementsByClassName('variant-input-wrap');
if (variantInputs && variantInputs.length > 0){
  Array.from(variantInputs).forEach(item => item.addEventListener('change', function(event){
    Wishlist.updatePDPHeart();
  }));
}

document.addEventListener('DOMContentLoaded', function(){
  Wishlist.updateHearts();
});

window.addEventListener("klaviyoForms", function(event) {
  if (event.detail.type == 'submit' && event.detail.formId == 'SAqSWP') {
    const wishlistItems = Wishlist.getItems();
    if (wishlistItems) {
      event.detail.metaData['items'] = Object.values(wishlistItems);
      event.detail.metaData['items'].map(function(item) {
        if (item['optionNames'] && item['optionValues']) {
          item['options'] = item['optionNames'].map((optionName, index) => optionName.concat(': ',item['optionValues'][index]));
        }
        if (item['CustomOptionNames'] && item['CustomOptionValues']) {
          item['customOptions'] = item['CustomOptionNames'].map((optionName, index) => optionName.concat(': ',item['CustomOptionValues'][index]));
        }
        item['specialprice'] = item['price'];
        if(!"18Hundert,Möbelzubehör,Möbelpflege,Terrafine".includes(item.collections)){
          //item['price'] = Math.round(item['price'] * 1.2165);
          item['specialprice'] = Math.round(item['price'] * 1.2165);
        }
      });

      _learnq.push(['track', 'Wishlist Email', event.detail.metaData]);
    }
  }
});
